import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M5.5,0.5h0.5v0.5h-0.5zM-4,1h2.5v0.5h-2.5zM3,1h1v0.5h-1z' },
    {
      paint: 'rock',
      d: 'M-0.5,-9h0.5v0.5h-0.5zM-2,-8.5h0.5v0.5h-0.5zM-1,-8.5h1.5v0.5h-1.5zM-2.5,-8h3v0.5h-3zM-3,-7.5h3.5v0.5h-3.5zM-3.5,-7h4v1h-4zM-4,-6h4v1h-4zM-4.5,-5h5v1h-5zM-5,-4h5.5v1h-5.5zM-5.5,-3h6.5v1h-6.5zM-6,-2h1v0.5h-1zM-4.5,-2h5.5v0.5h-5.5zM-6.5,-1.5h1v1h-1zM-4.5,-1.5h0.5v0.5h-0.5zM-3,-1.5h4.5v1h-4.5zM-7,-0.5h1.5v0.5h-1.5zM-2.5,-0.5h4v0.5h-4zM-7,0h1v0.5h-1zM-2.5,0h2.5v0.5h-2.5zM0.5,0h1v0.5h-1zM-5.5,0.5h3.5v0.5h-3.5zM-1.5,1h2.5v0.5h-2.5zM1.5,1h0.5v0.5h-0.5z',
    },
    {
      paint: 'boulder',
      d: 'M1,-8h1v0.5h-1zM0.5,-7.5h2v0.5h-2zM0.5,-7h3v1h-3zM0,-6h4v1h-4zM0.5,-5h4v1h-4zM0.5,-4h4.5v1h-4.5zM1,-3h4.5v1h-4.5zM-5,-2h0.5v0.5h-0.5zM1,-2h5v0.5h-5zM-5.5,-1.5h0.5v0.5h-0.5zM-4,-1.5h1v0.5h-1zM1.5,-1.5h5v0.5h-5zM1.5,-1h1.5v1h-1.5zM5,-1h1.5v0.5h-1.5zM-3,-0.5h0.5v0.5h-0.5zM5,-0.5h2v0.5h-2zM1.5,0h2v0.5h-2zM5.5,0h1.5v0.5h-1.5zM2,0.5h3.5v0.5h-3.5zM2,1h1v0.5h-1z',
    },
    {
      paint: 'epicMarble',
      d: 'M-1,-13h1v0.5h-1zM-1.5,-12h0.5v0.5h-0.5zM-1.5,-8.5h0.5v0.5h-0.5zM-3,-8h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-1,-12.5h1v1h-1zM-1.5,-11.5h1.5v0.5h-1.5zM-2,-11h2v1.5h-2zM-2.5,-9.5h3v0.5h-3zM-2.5,-9h2v0.5h-2zM0,-9h0.5v0.5h-0.5zM-3,-8.5h1v0.5h-1z',
    },
    {
      paint: 'ice',
      d: 'M0,-13h1v0.5h-1zM0,-12.5h1.5v1.5h-1.5zM0,-11h2v1.5h-2zM0.5,-9.5h2v1h-2zM0.5,-8.5h2.5v0.5h-2.5zM0.5,-8h0.5v0.5h-0.5zM2,-8h1v0.5h-1zM2.5,-7.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'pine',
      d: 'M-5,-1.5h0.5v0.5h-0.5zM-5.5,-1h2.5v1h-2.5zM3,-1h2v1h-2zM-6,0h3.5v0.5h-3.5zM3.5,0h2v0.5h-2zM-6,0.5h0.5v0.5h-0.5z',
    },
    { paint: 'epicCrystal', d: 'M0,0h0.5v0.5h-0.5zM-2,0.5h4v0.5h-4zM1,1h0.5v0.5h-0.5z' },
  ],
  pixels: 453,
};
export const sprites: readonly PixelSprite[] = [variant0];
